import { Link } from "react-router-dom";

const footerLinks = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "About", to: "/about" },
  { label: "Colorado Springs", to: "/location" },
];

export default function Footer() {
  return (
    <footer className="bg-[#141414] text-white">
      <div className="max-w-7xl mx-auto px-6 pt-16 pb-8">
        {/* Brand name large */}
        <p className="font-heading font-bold text-5xl lg:text-6xl tracking-tight text-white/10 select-none mb-12">
          WESTEC BUILDERS
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* About */}
          <div>
            <div className="mb-4">
              <img
                src="https://storage.readdy-site.link/project_files/4919a3d8-a024-46be-8105-a51ccf5c6eed/37fd96f4-a6bd-46d3-b823-ee4bb75b1a06_M179026---Web360-MU---Logo.png?v=e3931809e172ac5bc78535d28d071904"
                alt="Westec Builders Logo"
                className="h-10 w-auto object-contain brightness-0 invert"
              />
            </div>
            <p className="text-sm text-white/60 leading-relaxed font-body mb-6">
              Premium residential and commercial construction company serving Colorado Springs and surrounding communities. Licensed, insured, and built on craftsmanship.
            </p>
            <div className="flex gap-3">
              {["ri-facebook-fill", "ri-instagram-line", "ri-linkedin-fill", "ri-twitter-x-fill"].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  rel="nofollow"
                  className="w-9 h-9 flex items-center justify-center border border-white/20 rounded-full hover:border-brand-amber hover:text-brand-amber transition-colors cursor-pointer"
                >
                  <i className={`${icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <p className="text-xs font-body font-semibold uppercase tracking-widest text-white/40 mb-4">Quick Links</p>
            <div className="flex flex-col gap-3">
              {footerLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="text-sm font-body text-white/70 hover:text-brand-amber transition-colors cursor-pointer"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <p className="text-xs font-body font-semibold uppercase tracking-widest text-white/40 mb-4">Contact</p>
            <div className="flex flex-col gap-4">
              <div>
                <p className="text-xs text-white/40 font-body uppercase tracking-wide mb-1">Address</p>
                <p className="text-sm text-white/80 font-body">Colorado Springs, CO</p>
                <p className="text-sm text-white/80 font-body">United States</p>
              </div>
              <div>
                <p className="text-xs text-white/40 font-body uppercase tracking-wide mb-1">Phone</p>
                <a href="tel:+17195550100" className="text-sm text-white/80 font-body hover:text-brand-amber transition-colors cursor-pointer">(719) 555-0100</a>
              </div>
              <div>
                <p className="text-xs text-white/40 font-body uppercase tracking-wide mb-1">Email</p>
                <a href="mailto:info@westecbuilders.com" className="text-sm text-white/80 font-body hover:text-brand-amber transition-colors cursor-pointer">info@westecbuilders.com</a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40 font-body">
            &copy; {new Date().getFullYear()} Westec Builders. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="#" rel="nofollow" className="text-xs text-white/40 hover:text-white/70 font-body cursor-pointer transition-colors">Privacy Policy</a>
            <a href="#" rel="nofollow" className="text-xs text-white/40 hover:text-white/70 font-body cursor-pointer transition-colors">Terms of Service</a>
            <a href="#" rel="nofollow" className="text-xs text-white/40 hover:text-white/70 font-body cursor-pointer transition-colors">Sitemap</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
